<div class="snackbar-container">
    <span tabindex="0" [attr.aria-label]="message" auto_id="text_NotificationMessage">{{ message }}</span>
    <div class="mat-simple-snackbar-action">
        <button mat-icon-button (click)="snackBarRef.dismiss()" auto_id="button_NotificationCloseButton">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
